import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import { H1, H3, Body1, Body2 } from "../../../assets/styles/Typography";
import MoleculeHeader from "../components/molecules/MoleculeHeader";
import { useAtom } from "jotai";
import { IS_LOGGED_IN, USER_NAME, USER_EMAIL } from "../../AtomStates";
// import MoleculeInquiry from "../components/molecules/MoleculeInquiry";
import MoleculeInquiryWrite from "../components/molecules/MoleculeInquiryWrite";
import MoleculeInquiryList from "../components/molecules/MoleculeInquiryList";
import MoleculeAccount from "../../LoginSign/components/molecules/MoleculeAccount";
import images from "../../../assets/styles/Images";

const PageMyPage = () => {
  const navigate = useNavigate();
  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [userName] = useAtom(USER_NAME);
  const [userEmail] = useAtom(USER_EMAIL);
  const [activeTab, setActiveTab] = useState("inquiry");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handlePasswordChangeSuccess = () => {
    setShowSuccessPopup(true);
  };

  const handleSuccessConfirm = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/Login";
  };

  return (
    <>
      <MoleculeHeader centerTitle="계정 관리" />
      <PageContainer>
        <ContentWrapper>
          <PageHeader>
          </PageHeader>
         <TabRow>
          <TabNavigation>
            <TabButton
              active={activeTab === "inquiry"}
              onClick={() => setActiveTab("inquiry")}
            >
              1:1 문의하기
            </TabButton>
            <TabButton
              active={activeTab === "inquiryHistory"}
              onClick={() => setActiveTab("inquiryHistory")}
            >
              문의 내역 확인
            </TabButton>
            <TabButton
              active={activeTab === "password"}
              onClick={() => setActiveTab("password")}
            >
              비밀번호 변경
            </TabButton>
          </TabNavigation>

              <BackButton onClick={() => navigate(-1)} className="tabBack">
          <img src={images.ArrowBarLeft} alt="뒤로가기" />
          <span>돌아가기</span>
        </BackButton>
        </TabRow>

          <TabContent>
            {activeTab === "inquiry" && (
              <MoleculeInquiryWrite isLoggedIn={isLoggedIn} />
            )}

            {activeTab === "inquiryHistory" && (
             <MoleculeInquiryList isLoggedIn={isLoggedIn} />
            )}

            {activeTab === "password" && (
              <PasswordChangeWrapper>
                <MoleculeAccount onOpenPopup={handlePasswordChangeSuccess} />
              </PasswordChangeWrapper>
            )}
          </TabContent>
        </ContentWrapper>
      </PageContainer>
      {showSuccessPopup && (
        <SuccessPopup onClick={handleSuccessConfirm}>
          <div>
            <span>
              <img src={images.CheckMark} alt="" />
            </span>
            <p>
              <strong>비밀번호가 변경되었습니다.</strong>
              <span>다시 로그인해주세요.</span>
            </p>
            <div className="btnWrap">
              <button type="button" onClick={handleSuccessConfirm}>
                확인
              </button>
            </div>
          </div>
        </SuccessPopup>
      )}
    </>
  );
};

export default PageMyPage;

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: ${palette.gray50};
  padding-top: 54px;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 72px 24px;
`;

const PageHeader = styled.div`
  margin-bottom: 32px;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  margin-bottom: 4px;
  border: none;
  background: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  font-family: "Pretendard";
  color: ${palette.gray600};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  img {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: ${palette.gray100};
    color: ${palette.gray800};
  }
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 16px;
`;

const TabNavigation = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

const TabButton = styled.button`
  padding: 12px 24px;
  border: none;
  background: none;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => (props.active ? palette.primary : palette.gray600)};
  border-bottom: 2px solid
    ${(props) => (props.active ? palette.primary : "transparent")};
  margin-bottom: -2px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: ${palette.primary};
  }
`;

const TabContent = styled.div`
  width: 100%;
`;

const PasswordChangeWrapper = styled.div`
  width: 100%;
  padding: 24px;
  background: ${palette.white};
  border-radius: 12px;
  border: 1px solid ${palette.outlineGray};
`;

const SuccessPopup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.5s;
  z-index: 9999;

  > div {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;
    text-align: center;
    padding: 45px 24px 24px;
    border-radius: 10px;
    background: ${palette.white};

    span {
      display: flex;
      justify-content: center;
    }

    p {
      font-family: "Pretendard", "Poppins";
      font-size: 0.9375rem;
      font-weight: 600;
      margin: 16px auto 24px;
      strong {
        font-weight: 600;
        display: block;
      }
      span {
        font-size: 0.875rem;
        display: block;
        margin-top: 8px;
        color: ${palette.gray500};
      }
    }

    .btnWrap {
      display: flex;
      align-items: center;
      gap: 16px;
      padding-top: 16px;
      border-top: 1px solid ${palette.lineGray};

      button {
        margin: auto;
        font-family: "Pretendard", "Poppins";
        font-size: 14px;
        font-weight: 600;
        font-family: "Pretendard";
        color: ${palette.blue};
        padding: 0;
        border-radius: 0;
        border: 0;
        background: none;
        cursor: pointer;
      }
    }
  }
`;

const TabRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid ${palette.outlineGray};
  margin-bottom: 32px; /* 기존 TabNavigation의 margin-bottom을 여기로 이동 */
  padding-bottom: 0px;
`;

